import { AfterContentInit, Directive, ElementRef, Input } from '@angular/core';

/**
 * autofocus directive provides a convenient way to trigger
 * focus on an input field after content is initialized,
 * e.g. when modal is shown and content rendered
 *
 * elemment will get focused when `autoFocused` property is set.
 */
@Directive({
    selector: '[autoFocused]',
    standalone: true
})
export class AutoFocusDirective implements AfterContentInit {
    constructor(private el: ElementRef) {
        /**  */
    }

    /**
     * lifecycle hook after content is initialized
     * after a timeout of 500 milliseconds focus on element is set
     */
    public ngAfterContentInit(): void {
        setTimeout(() => {
            this.el.nativeElement.focus();
        }, 500);
    }
}
